<template>
  <LayoutPage>
    <div class="mt-6 mb-6 grid grid-cols-2 w-full">
      <div>
        <router-link :to="{ name: 'SocialMediaView' }" class="text-gray-600 hover:text-black">
          <i class="text-2xl el-icon-back"></i>
        </router-link>
        <h1 class="text-2xl inline-block ml-2">Edit Social Media</h1>
      </div>
    </div>
    <div class="" style="min-height: 500px" v-loading="loading">
      <template v-if="loaded">
        <template v-if="loadError">
          <div>{{ `Something goes wrong` }}</div>
        </template>
        <template v-else>
          <div class="align-middle inline-block w-full">
            <EditForm :channelId="channelId" v-model="formModel" :buttons="formButtons" key="edit-social-media" />
          </div>
        </template>
      </template>
    </div>
  </LayoutPage>
</template>
<script>
import { onMounted, reactive, toRefs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import EditForm from '../components/EditForm.vue'
import { saveChannelProviderInfo, fetchProviderDetailItem } from '@/services/channelService'
import { ElMessageBox, ElMessage } from 'element-plus'
export default {
  components: {
    EditForm
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      loaded: false,
      loading: false,
      loadError: false,
      formModel: {},
      channelId: null,
      formButtons: [
        { label: 'Save Changes', type: 'submit', isLoading: false, attrs: { type: 'primary' }, onClick: () => submitForm() },
        { label: 'Cancel', type: 'cancel', isLoading: false, attrs: {}, onClick: () => router.push({ name: 'SocialMediaView' }) }
      ]
    })
    function populatePayload(payload) {
      payload.settings.isVerified = false
      return payload
    }
    async function submitForm() {
      state.formButtons[0].isLoading = true
      try {
        const result = await saveChannelProviderInfo({ id: route.params.id, ...populatePayload(state.formModel) })
        if (!result.data.success) {
          ElMessageBox.alert(result.data.message, 'Error', {
            confirmButtonText: 'OK'
          })
        } else {
          ElMessage({ type: 'success', message: 'Provider updated.' })
          router.push({ name: 'SocialMediaView' })
        }
      } catch {
        ElMessageBox.alert('Something went wrong when saving social provider. Please try again later!', 'Error', {
          confirmButtonText: 'OK'
        })
      }
      state.formButtons[0].isLoading = false
    }
    async function initializeData() {
      state.loading = true
      try {
        state.channelId = route.params.id
        const { data } = await fetchProviderDetailItem('social', route.params.id)
        const result = data[0]
        if (result.settings.is_verified) {
          // Disabled button
          state.formButtons[0].label = 'Verified'
          state.formButtons[0].attrs = { class: 'pointer-events-none', ...state.formButtons.attrs, type: 'success' }
        }
        state.formModel = result
      } catch {
        state.loadError = true
      }
      state.loaded = true
      state.loading = false
    }
    onMounted(() => initializeData())
    return {
      ...toRefs(state)
    }
  }
}
</script>
